module.exports = __webpack_public_path__ + "static/media/info-filled.747d7b08.svg";